/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { oxygenYield } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const YIELD_OFFER_DETAILS = 'yield.offerDetails';
export const YIELD_OFFER_ACTIVATE = 'yield.activateOffer';

queryClient.setMutationDefaults(YIELD_OFFER_DETAILS, {
  mutationFn: oxygenYield.offerDetails,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(YIELD_OFFER_ACTIVATE, {
  mutationFn: oxygenYield.activateOffer,
  onError: (error) => {
    handleError(error);
  },
});
